import styled from "styled-components";
import { Fragment } from "react";
// import Link from 'next/link'
import { Popover, Transition } from "@headlessui/react";
import clsx from "clsx";

import { Button } from "../Button";
import { Container } from "../Container";
import { Logo } from "../Logo";
import { NavLink } from "../NavLink";
import { siteSettings } from "../../static";

const menuItems = [
  {
    name: "General",
    icon: "./icons/general.svg",
    text: false,
    arrow: true,
    class: "general",
  },
  {
    name: "Futures",
    icon: false,
    text: "Futures",
    arrow: true,
    class: "futures",
  },
  {
    name: "Spot",
    icon: false,
    text: "Spot",
    arrow: true,
    class: "spot",
  },
  // {
  //   name: "Explore Trading",
  //   icon: false,
  //   text: "Explore Trading",
  //   arrow: true,
  //   class: "explore",
  // },
  {
    name: "Copy Trading",
    icon: "./icons/fire.svg",
    text: "Copy Trading",
    arrow: true,
    class: "copy",
  },
  {
    name: "Staking",
    icon: false,
    text: "Staking",
    arrow: true,
    class: "staking",
  },
];

const generalItems = [
  {
    sectionTitle: `${siteSettings.siteName} Platform`,
    sectionItems: [
      {
        title: "About Us",
        text: "Find out more about our company",
        link: "/about",
      },
      {
        title: "Contact Us",
        text: "Have any questions? Let's get in touch",
        link: "/contact",
      },
      // {
      //   title: "Fees",
      //   text: "Get to know our trading and funding fees",
      // },
      {
        title: "Security",
        text: "Learn more about how Liquid Markets protects its users",
        link: "/security",
      },
      {
        title: "Send us an email",
        text: `${siteSettings.siteName}'s 24/7 email support is always at your service`,
        link: `mailto:${siteSettings.supportEmail}`,
      },
    ],
  },
];

const futuresItems = [
  {
    title: "COIN-M",
    text: "Perpetual futures settled in cryptocurrency as margin (BTC,ETH, LTC & more)",
    tag: "Popular",
    tagColor: "blue",
  },
  {
    title: "USDT-M",
    text: "Perpetual futures settled in stable coins (USDT/USDC/DAI etc)",
    tag: "Popular",
    tagColor: "blue",
  },
  {
    title: "Simulated",
    text: "Risk-free trading with demo funds ",
    tag: "New",
    tagColor: "green",
    // (No deposit required)
  },
];

const spotItems = [
  {
    title: "Convert crypto",
    text: "The easiest way to trade crypto",
    tag: "New",
    tagColor: "green",
  },
  {
    title: "Spot trading",
    text: "Trade crypto on a spot exchange",
    tag: "In Development",
    tagColor: "grey",
  },
];

const exploreItems = [
  {
    title: "Quick start guide",
    text: "Learn how to start trading on Liquid Markets in 60 seconds",
    tag: "Hot",
    tagColor: "red",
  },
  {
    title: "Video tutorials",
    text: "Take a look at our video tutorials to familiarize yourself with trading on Liquid Markets",
    tag: "Popular",
    tagColor: "blue",
  },
  {
    title: "How to make a deposit",
    text: "Detailed information on how to make a deposit",
    tag: "Popular",
    tagColor: "blue",
  },
  {
    title: "How to buy cryto",
    text: "Explore all the ways to buy crypto",
    tag: "Best Offer",
    tagColor: "green",
  },
  {
    title: "Trading on Liquid Markets",
    text: "Full platform overview and guides",
    tag: null,
    tagColor: null,
  },
  {
    title: "Cross vs Isolated Margin",
    text: "What is the difference between cross and isolated margin? Let's find out.",
    tag: null,
    tagColor: null,
  },
  {
    title: "Crypto Futures trading",
    text: "Everything you need to know about futures trading",
    tag: null,
    tagColor: null,
  },

  {
    title: "How to short crypto",
    text: "A complete guide to shorting cryptocurrencies",
    tag: null,
    tagColor: null,
  },
  {
    title: "Leverage Trading and Margin",
    text: "Detailed information about trading with leverage",
    tag: null,
    tagColor: null,
  },
];

const copyItems = [
  {
    title: "Start Copy Trading",
    text: "Copy proven traders on autopilot in one-click",
    tag: "Hot",
    tagColor: "red",
  },
  // {
  //   title: "Copy Trading overview",
  //   text: "What is copy trading? Why is Liquid Markets Copy Trading the best solution on the market?",
  //   tag: null,
  //   tagColor: null,
  // },
  // {
  //   title: "How to Start Following a Public Trader?",
  //   text: "Simple instructions on how to start following a trader",
  //   tag: null,
  //   tagColor: null,
  // },
];

const stakingItems = [
  {
    title: "Bitcoin (BTC)",
    text: "Earn",
    apy: "3% APY",
    tag: "Hot",
    tagColor: "red",
  },
  {
    title: "Ethereum (ETH)",
    text: "Earn",
    apy: "4.7% APY",
    tag: null,
    tagColor: null,
  },
  {
    title: "Tether (USDT)",
    text: "Earn",
    apy: "5% APY",
    tag: "Best Offer",
    tagColor: "green",
  },
  {
    title: "USD Coin (USDC)",
    text: "Earn",
    apy: "5% APY",
    tag: null,
    tagColor: null,
  },
];

const HeaderNew = () => {
  return (
    <>
      <HeaderDesktop>
        {/* header:left__desktop */}
        <div
          style={{
            display: "flex",
            gap: "12px",
            alignItems: "center",
          }}
        >
          {/* logo */}
          {/* <svg
            viewBox="0 0 137 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="137"
            height="28"
            class="Header__StyledLogoIcon-sc-agwv5z-5 ArlAa"
          >
            <path
              d="m0 18.978 5.327 4.511L0 28v-9.02zm27.995 0-5.327 4.511L27.995 28v-9.02zM0 0v9.022l14 11.845L28 9.022V0L14 11.845 0 0z"
              fill="#3071EE"
            ></path>
            <path d="M0 9.022V0l14 11.845v9.022L0 9.022z" fill="#3071EE"></path>
            <path d="M28 0v9.022L14 20.867v-9.022L28 0z" fill="#2D54DE"></path>
            <path d="m0 18.978 5.327 4.511L0 28v-9.02z" fill="#3071EE"></path>
            <path
              d="m27.995 18.978-5.327 4.511L27.995 28v-9.02z"
              fill="#2D54DE"
            ></path>
            <path
              class="logo-label"
              d="M52.29 5.95h-3.64l-4.322 7.075-4.323-7.075h-3.64v15.925h3.64v-9.26l4.118 6.758h.41l4.117-6.757v9.26h3.64V5.95zm14.226 15.925h3.981L65.083 5.95h-4.641l-5.415 15.925h3.982l.796-2.502h5.915l.796 2.502zm-5.62-5.915 1.866-5.847 1.866 5.847h-3.731zm20.696 5.915h3.913l-3.39-5.847c1.752-.887 2.935-2.661 2.935-4.618a5.447 5.447 0 0 0-5.46-5.46h-6.37v15.925h3.64v-5.232h1.73l3.002 5.232zM76.86 9.363h2.73c1.001 0 1.82.887 1.82 2.047 0 1.16-.819 2.048-1.82 2.048h-2.73V9.363zm27.265 3.64H96.14v3.185h4.254c-.568 1.524-1.956 2.457-4.072 2.457-3.094 0-5.005-1.98-5.005-4.687 0-2.798 2.002-4.777 4.687-4.777 1.797 0 3.23.819 3.89 1.865l3.094-1.774c-1.342-2.139-3.913-3.64-6.962-3.64-4.686 0-8.349 3.685-8.349 8.303 0 4.573 3.595 8.259 8.6 8.259 4.459 0 7.848-2.958 7.848-7.826v-1.365zm7.058 5.369V15.55h5.687v-3.458h-5.687v-2.64h6.256V5.95h-9.896v15.925h10.01v-3.503h-6.37zm22.301 3.503-4.755-8.167 4.527-7.758h-4.14l-2.457 4.209-2.457-4.209h-4.141l4.528 7.758-4.755 8.167h4.14l2.685-4.595 2.684 4.595h4.141z"
            ></path>
          </svg> */}
          <a href="/">
            <img src="./logo-full.png" alt="logo" style={{ width: "164px" }} />
          </a>

          <div className="nav">
            {menuItems.map((item) => (
              <div className={`nav__item ${item.class}`}>
                {/* text */}
                {item.text && <p>{item.text}</p>}

                {/* icon */}
                {item.icon && (
                  <img src={item.icon} alt={item.icon} className="icon" />
                )}

                {/* arrow */}
                {item.arrow && (
                  <img src="./icons/arrow.svg" alt="arrow" className="arrow" />
                )}

                {/* dropdowns */}

                {/* general */}
                <div className="menu general">
                  {/* section:platform */}
                  {generalItems.map((section) => (
                    <section>
                      <p className="section__title">{section.sectionTitle}</p>

                      <div className="section__content">
                        {section.sectionItems.map((item) => (
                          <div className="section__item">
                            <a className="section__item__desc" href={item.link}>
                              <p>{item.title}</p>
                              <p>{item.text}</p>
                            </a>
                          </div>
                        ))}
                      </div>
                    </section>
                  ))}
                </div>

                {/* futures */}
                <div className="menu futures">
                  <section>
                    <div className="section__content">
                      {futuresItems.map((item) => (
                        <div className="section__item">
                          <a
                            className="section__item__desc"
                            href={siteSettings.appLink}
                          >
                            <span
                              style={{
                                display: "flex",
                                gap: "6px",
                                alignItems: "center",
                              }}
                            >
                              <p>{item.title}</p>
                              <span className={`${item.tagColor}`}>
                                {item.tag}
                              </span>
                            </span>
                            <p>{item.text}</p>
                          </a>
                        </div>
                      ))}
                    </div>
                  </section>
                </div>

                {/* spot */}
                <div className="menu spot">
                  <section>
                    <div className="section__content">
                      {spotItems.map((item) => (
                        <div className="section__item">
                          <a
                            className="section__item__desc"
                            href={siteSettings.appLink}
                          >
                            <span
                              style={{
                                display: "flex",
                                gap: "6px",
                                alignItems: "center",
                              }}
                            >
                              <p>{item.title}</p>
                              <span className={`${item.tagColor}`}>
                                {item.tag}
                              </span>
                            </span>
                            <p>{item.text}</p>
                          </a>
                        </div>
                      ))}
                    </div>
                  </section>
                </div>

                {/* explore */}
                <div className="menu explore">
                  <section>
                    <div className="section__content">
                      {exploreItems.map((item) => (
                        <div className="section__item">
                          <div className="section__item__desc">
                            <span
                              style={{
                                display: "flex",
                                gap: "6px",
                                alignItems: "center",
                              }}
                            >
                              <p>{item.title}</p>
                              {item.tag && (
                                <span className={`${item.tagColor}`}>
                                  {item.tag}
                                </span>
                              )}
                            </span>
                            <p>{item.text}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </section>
                </div>

                {/* copy */}
                <div className="menu copy">
                  <section>
                    <div className="section__content">
                      {copyItems.map((item) => (
                        <div className="section__item">
                          <a
                            className="section__item__desc"
                            href={`${siteSettings.appLink}/copy`}
                          >
                            <span
                              style={{
                                display: "flex",
                                gap: "6px",
                                alignItems: "center",
                              }}
                            >
                              <p>{item.title}</p>
                              {item.tag && (
                                <span className={`${item.tagColor}`}>
                                  {item.tag}
                                </span>
                              )}
                            </span>
                            <p>{item.text}</p>
                          </a>
                        </div>
                      ))}
                    </div>
                  </section>
                </div>

                {/* staking */}
                <div className="menu staking">
                  <section>
                    <div className="section__content">
                      {stakingItems.map((item) => (
                        <div className="section__item">
                          <a
                            className="section__item__desc"
                            href={`${siteSettings.appLink}/staking`}
                          >
                            <span
                              style={{
                                display: "flex",
                                gap: "6px",
                                alignItems: "center",
                              }}
                            >
                              <p>{item.title}</p>
                              {item.tag && (
                                <span className={`${item.tagColor}`}>
                                  {item.tag}
                                </span>
                              )}
                            </span>
                            <p>{item.text}</p>
                          </a>
                        </div>
                      ))}
                    </div>
                  </section>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* header:right__desktop */}
        <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
          {/* globe */}
          {/* <img
            src="data:image/svg+xml;base64,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"
            alt="en"
            style={{ width: "24px" }}
          ></img> */}

          {/* phone */}
          {/* <img
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDRDNCAxLjc5MDg2IDUuNzkwODYgMCA4IDBIMTZDMTguMjA5MSAwIDIwIDEuNzkwODYgMjAgNFYyMEMyMCAyMi4yMDkxIDE4LjIwOTEgMjQgMTYgMjRIOEM1Ljc5MDg2IDI0IDQgMjIuMjA5MSA0IDIwVjRaTTYgNEM2IDIuODk1NDMgNi44OTU0MyAyIDggMkgxNkMxNy4xMDQ2IDIgMTggMi44OTU0MyAxOCA0VjE2QzE4IDE3LjEwNDYgMTcuMTA0NiAxOCAxNiAxOEg4QzYuODk1NDMgMTggNiAxNy4xMDQ2IDYgMTZWNFpNMTIgMjJDMTIuNTUyMyAyMiAxMyAyMS41NTIzIDEzIDIxQzEzIDIwLjQ0NzcgMTIuNTUyMyAyMCAxMiAyMEMxMS40NDc3IDIwIDExIDIwLjQ0NzcgMTEgMjFDMTEgMjEuNTUyMyAxMS40NDc3IDIyIDEyIDIyWiIgZmlsbD0iIzMwNzFFRSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjk5ODQgNS41QzEyLjI3NDYgNS41IDEyLjQ5ODQgNS43MjM4NiAxMi40OTg0IDZMMTIuNDk4NCAxMi44MTQ1TDE0LjQ5NDkgMTAuODE4QzE0LjY5MDEgMTAuNjIyOCAxNS4wMDY3IDEwLjYyMjggMTUuMjAyIDEwLjgxOEMxNS4zOTcyIDExLjAxMzMgMTUuMzk3MiAxMS4zMjk5IDE1LjIwMiAxMS41MjUxTDEyLjM3MzUgMTQuMzUzNkMxMi4yNzA0IDE0LjQ1NjcgMTIuMTMzNSAxNC41MDUzIDExLjk5ODQgMTQuNDk5NUMxMS44NjM0IDE0LjUwNTMgMTEuNzI2NCAxNC40NTY3IDExLjYyMzMgMTQuMzUzNkw4Ljc5NDg4IDExLjUyNTFDOC41OTk2MiAxMS4zMjk5IDguNTk5NjIgMTEuMDEzMyA4Ljc5NDg4IDEwLjgxOEM4Ljk5MDE1IDEwLjYyMjggOS4zMDY3MyAxMC42MjI4IDkuNTAxOTkgMTAuODE4TDExLjQ5ODQgMTIuODE0NUwxMS40OTg0IDZDMTEuNDk4NCA1LjcyMzg2IDExLjcyMjMgNS41IDExLjk5ODQgNS41WiIgZmlsbD0iIzMwNzFFRSIvPgo8L3N2Zz4K"
            alt="Download app"
            style={{ width: "24px" }}
          ></img> */}

          {/* buttons */}

          <div style={{ display: "flex", gap: "12px" }}>
            <a href={`${siteSettings.appLink}/login`}>
              <button
                style={{
                  textTransform: "uppercase",
                  padding: "6px 12px",
                  color: "#3071EE",
                  backgroundColor: "transparent",
                  outline: "none",
                  border: "1px solid #3071EE",
                  borderRadius: "4px",
                  fontFamily: "Open Sans",
                  fontWeight: "600",
                }}
              >
                Login
              </button>
            </a>
            <a href={`${siteSettings.appLink}/register`}>
              <button
                style={{
                  textTransform: "uppercase",
                  padding: "6px 12px",
                  color: "#fff",
                  backgroundColor: "#3071EE",
                  outline: "none",
                  border: "1px solid #3071EE",
                  borderRadius: "4px",
                  fontFamily: "Open Sans",
                  fontWeight: "600",
                }}
              >
                Start trading
              </button>
            </a>
          </div>
        </div>
      </HeaderDesktop>
    </>
  );
};

function MobileNavLink({ href, children }) {
  return (
    <Popover.Button as={"a"} href={href} className="block w-full p-2">
      {children}
    </Popover.Button>
  );
}

function MobileNavIcon({ open }) {
  return (
    <svg
      aria-hidden="true"
      className="h-3.5 w-3.5 overflow-visible stroke-slate-700"
      fill="none"
      strokeWidth={2}
      strokeLinecap="round"
    >
      <path
        d="M0 1H14M0 7H14M0 13H14"
        className={clsx(
          "origin-center transition",
          open && "scale-90 opacity-0"
        )}
      />
      <path
        d="M2 2L12 12M12 2L2 12"
        className={clsx(
          "origin-center transition",
          !open && "scale-90 opacity-0"
        )}
      />
    </svg>
  );
}

function MobileNavigation() {
  return (
    <Popover>
      <Popover.Button
        className="relative z-10 flex h-8 w-8 items-center justify-center [&:not(:focus-visible)]:focus:outline-none"
        aria-label="Toggle Navigation"
      >
        {({ open }) => <MobileNavIcon open={open} />}
      </Popover.Button>
      <Transition.Root>
        <Transition.Child
          as={Fragment}
          enter="duration-150 ease-out"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="duration-150 ease-in"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Popover.Overlay className="fixed inset-0 bg-slate-300/50" />
        </Transition.Child>
        <Transition.Child
          as={Fragment}
          enter="duration-150 ease-out"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="duration-100 ease-in"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Popover.Panel
            as="div"
            className="absolute inset-x-0 top-full mt-4 flex origin-top flex-col rounded-2xl bg-white p-4 text-lg tracking-tight text-slate-900 shadow-xl ring-1 ring-slate-900/5"
          >
            <MobileNavLink href="/about">About us</MobileNavLink>
            <MobileNavLink href="/terms">Terms and conditions</MobileNavLink>
            <MobileNavLink href="/copy">Copy Trading</MobileNavLink>
            <MobileNavLink href="/staking">Staking</MobileNavLink>
            <hr className="m-2 border-slate-300/40" />
            <MobileNavLink href={`${siteSettings.appLink}/login`}>
              Log in
            </MobileNavLink>
            <MobileNavLink href={`${siteSettings.appLink}/register`}>
              Register
            </MobileNavLink>
          </Popover.Panel>
        </Transition.Child>
      </Transition.Root>
    </Popover>
  );
}

export function HeaderActual() {
  return (
    <header className="py-10">
      <Container>
        <nav className="relative z-50 flex justify-between">
          <div className="flex items-center md:gap-x-12">
            <a href="/" aria-label="Home">
              <Logo className="h-10 w-auto" />
            </a>
            <div className="hidden md:flex md:gap-x-6">
              <NavLink href="/about">About us</NavLink>
              <NavLink href="/copy">Copy Trading</NavLink>
              <NavLink href="/staking">Staking</NavLink>
            </div>
          </div>
          <div className="flex items-center gap-x-5 md:gap-x-8">
            <div className="hidden md:block">
              <NavLink href={`${siteSettings.appLink}/login`}>Log in</NavLink>
            </div>
            <Button href={`${siteSettings.appLink}/register`} color="blue">
              <span>
                Get started <span className="hidden lg:inline">today</span>
              </span>
            </Button>
            <div className="-mr-1 md:hidden">
              <MobileNavigation />
            </div>
          </div>
        </nav>
      </Container>
    </header>
  );
}

const Header = () => {
  return (
    <HeaderBoth>
      <div className="desktop">
        <HeaderNew />
      </div>

      <div className="mobile">
        <HeaderActual />
      </div>
    </HeaderBoth>
  );
};

const HeaderBoth = styled.div`
  .desktop {
    display: block;
  }

  .mobile {
    display: none;
  }

  .desktop {
    @media screen and (max-width: 1200px) {
      display: none;
    }
  }

  .mobile {
    @media screen and (max-width: 1200px) {
      display: block;
    }
  }
`;

const HeaderDesktop = styled.div`
  /* background-color: red; */
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 16px 0px;
  z-index: 99999;
  position: relative;
  padding: 16px 32px;

  .nav {
    display: flex;
    gap: 12px;
    position: relative;
  }

  .nav__item {
    display: flex;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: 600;
    color: #324875;
    align-items: center;
    cursor: pointer;
  }

  .nav__item:hover .arrow {
    transform: rotateZ(180deg);
    transition: all 0.1s ease;
  }

  .nav__item .icon {
    width: 24px;
  }

  .nav__item .arrow {
    margin-left: 4px;
    margin-top: 4px;
  }

  .section__item {
    padding: 8px;
    border-radius: 4px;
  }

  .section__item:hover {
    background: linear-gradient(0deg, rgb(215, 220, 228), rgb(195, 202, 212)),
      rgb(18, 52, 130);
  }

  .menu {
    position: absolute;
    background: linear-gradient(0deg, rgb(243, 247, 253), rgb(243, 247, 253)),
      rgb(18, 52, 130);
    box-shadow: rgba(15, 42, 102, 0.7) 0px 15px 50px;

    left: 0px;
    top: 60px;
    border-radius: 8px;
    width: 100%;
    padding: 32px;
    max-width: max-content;
    color: rgb(19, 22, 34);
    transition: opacity 0.4s ease 0s, visibility 0.4s ease 0s;
  }

  .blue {
    padding: 2px 0.5rem;
    text-transform: capitalize;
    background: linear-gradient(
      rgba(48, 170, 238, 0.9) 0%,
      rgba(48, 170, 238, 0.54) 100%
    );
    box-shadow: rgba(48, 170, 238, 0.25) 0px 4px 4px;
    color: rgb(247, 252, 255);
    border-radius: 24px;
    font-weight: 600;
    font-size: 0.625rem;
    line-height: 21px;
    white-space: nowrap;
  }

  .green {
    padding: 2px 0.5rem;
    text-transform: capitalize;
    background: linear-gradient(
      rgba(21, 184, 57, 0.9) 0%,
      rgba(21, 184, 57, 0.54) 100%
    );
    box-shadow: rgba(21, 184, 57, 0.25) 0px 4px 4px;
    color: rgb(247, 252, 255);
    border-radius: 24px;
    font-weight: 600;
    font-size: 0.625rem;
    line-height: 21px;
    white-space: nowrap;
  }

  .grey {
    padding: 2px 0.5rem;
    text-transform: capitalize;
    background: linear-gradient(
      rgba(147, 151, 184, 0.9) 0%,
      rgba(147, 151, 184, 0.54) 100%
    );
    box-shadow: rgba(147, 151, 184, 0.25) 0px 4px 4px;
    color: rgb(247, 252, 255);
    border-radius: 24px;
    font-weight: 600;
    font-size: 0.625rem;
    line-height: 21px;
    white-space: nowrap;
  }

  .red {
    padding: 2px 0.5rem;
    text-transform: capitalize;
    background: linear-gradient(
      rgba(238, 94, 48, 0.9) 0%,
      rgba(238, 94, 48, 0.54) 100%
    );
    box-shadow: rgba(238, 94, 48, 0.25) 0px 4px 4px;
    color: rgb(247, 252, 255);
    border-radius: 24px;
    font-weight: 600;
    font-size: 0.625rem;
    line-height: 21px;
    white-space: nowrap;
  }

  .menu.features {
  }

  .menu.spot {
  }

  .menu.general {
    left: 0px;
    /* display: none; */
    user-select: none;
    visibility: hidden;
  }

  .nav .menu.futures {
    left: 50px;
    /* display: none; */
    user-select: none;
    visibility: hidden;
  }

  .nav .menu.spot {
    left: 120px;
    /* display: none; */
    user-select: none;
    visibility: hidden;
  }

  .nav .menu.explore {
    left: 175px;
    /* display: none; */
    user-select: none;
    visibility: hidden;
  }

  .nav .menu.copy {
    left: 305px;
    /* display: none; */
    user-select: none;
    visibility: hidden;
  }

  .nav .menu.staking {
    left: 446px;
    user-select: none;
    visibility: hidden;
    /* transition: visibility 0.3s ease-in;
    transition-delay: 1s; */
  }

  .menu section .section__content {
    margin-top: 24px;
    display: grid;
    grid-template-columns: auto auto;
    grid-template-rows: auto auto;
    gap: 24px;
    width: 100%;
  }

  .menu.general .section__item {
    max-width: 240px;
  }

  .menu.futures section .section__content {
    display: flex;
    gap: 24px;
    flex-direction: column;
    max-width: max-content;
  }

  .menu.futures .section__item {
    max-width: 240px;
    width: 100%;
  }

  .menu.copy section .section__content {
    display: flex;
    gap: 24px;
    flex-direction: column;
    max-width: max-content;
  }

  .menu.copy .section__item {
    max-width: 240px;
    width: 100%;
  }

  .menu.spot section .section__content {
    display: flex;
    gap: 40px;
    flex-direction: column;
    max-width: max-content;
  }

  .menu.spot .section__item {
    max-width: 240px;
    width: 100%;
  }

  .menu.staking section .section__content {
    display: flex;
    gap: 40px;
    flex-direction: column;
    max-width: max-content;
  }

  .menu.staking .section__item {
    max-width: 240px;
    width: 100%;
  }

  .nav__item.general:hover .menu.general {
    /* display: block; */
    user-select: all;
    visibility: unset;
  }

  .nav__item.futures:hover .menu.futures {
    /* display: block; */
    user-select: all;
    visibility: unset;
  }

  .nav__item.spot:hover .menu.spot {
    /* display: block; */
    user-select: all;
    visibility: unset;
  }

  .nav__item.explore:hover .menu.explore {
    /* display: block; */
    user-select: all;
    visibility: unset;
  }

  .nav__item.copy:hover .menu.copy {
    /* display: block; */
    user-select: all;
    visibility: unset;
  }

  .nav__item.staking:hover .menu.staking {
    /* display: block; */
    user-select: all;
    visibility: unset;
  }

  .menu.staking:hover {
    display: block;
  }

  .menu section .section__title {
    font-size: 16px;
    font-weight: 600;
    font-family: "Open Sans";
    color: #324875;
  }

  .section__item .section__item__desc {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .section__item .section__item__desc p:nth-child(1) {
    font-size: 14px;
    font-weight: 600;
    font-family: "Open Sans";
    color: #324875;
    margin: 0;
    padding: 0;
    line-height: 20px;
    margin: 0;
    padding: 0;
  }

  .section__item .section__item__desc p:nth-child(2) {
    font-size: 14px;
    font-weight: 400;
    font-family: "Open Sans";
    color: #324875;
    line-height: 20px;
    margin: 0;
    padding: 0;
  }
`;

const HeaderMobile = styled.div``;

export default Header;
